module.exports = __webpack_public_path__ + "media/time-management_en_ipad_air.3cf76fec.mp4";